import logo from './logo.svg';
import './App.css';
import Home from './pages/home.js'
import About from './pages/about.js'
import Register from './pages/register/register'
import VerifyEmail from './pages/register/verify-email'
import PaymentCard from './pages/register/payment-card'
import PaymentDetail from './pages/register/payment-detail'
import Login from './pages/login'
import ForgotPasswordSendMail from './pages/forgot_password/send-mail'
import ForgotPassword from './pages/forgot_password/forgot-password'
import DashboardHome from './pages/dashboard/home'
import Dashboard from './pages/dashboard/dashboard'
import DashboardDocuments from './pages/dashboard/documents'
import DashboardSettings from './pages/dashboard/settings'
import DashboardModules from './pages/dashboard/modules'
import LessonRead from './pages/dashboard/modules-pages/lesson-read'
import Explanation from './pages/dashboard/modules-pages/explanation'
import QuizQuestion from './pages/dashboard/modules-pages/quiz-question'
import QuizPass from './pages/dashboard/modules-pages/quiz-pass'
import QuizFail from './pages/dashboard/modules-pages/quiz-fail'
import AudioPlay from './pages/dashboard/modules-pages/audio-play'
import ImageOrGif from './pages/dashboard/modules-pages/image-or-gif'
import AudioCard from './pages/dashboard/modules-pages/audio-card'
import Table from './pages/dashboard/modules-pages/table'
import CardSee from './pages/dashboard/modules-pages/card-see'
import CardHear from './pages/dashboard/modules-pages/card-hear'
import CardDo from './pages/dashboard/modules-pages/card-do'
import StudentSpeaking from './pages/dashboard/modules-pages/student-speaking'
import StudentCardCorrect from './pages/dashboard/modules-pages/student-card-correct'
import StudentCardFalse from './pages/dashboard/modules-pages/student-card-false'
import SyllableSee from './pages/dashboard/modules-pages/syllable-see'
import SyllableHear from './pages/dashboard/modules-pages/syllable-hear'
import SyllableDo from './pages/dashboard/modules-pages/syllable-do'
import SyllableStudentSpeak from './pages/dashboard/modules-pages/syllable-student-speak'
import SayVowels from './pages/dashboard/modules-pages/say-vowels'
import ListenToTeacher from './pages/dashboard/modules-pages/listen-to-teacher'
import ListenToTeacherCorrect from './pages/dashboard/modules-pages/listen-to-teacher-correct'
import ListenToTeacherWrong from './pages/dashboard/modules-pages/listen-to-teacher-wrong'
import CardVowelSee from './pages/dashboard/modules-pages/card-vowel-see'
import CardVowelHear from './pages/dashboard/modules-pages/card-vowel-hear'
import CardVowelDo from './pages/dashboard/modules-pages/card-vowel-do'
import ExamViewer from './components/exam/ExamViewer'
import CertificateViewer from './components/certificate/CertificateViewer'
import {BrowserRouter as Router, Route, Routes, useNavigate} from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { AuthProvider } from './context/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'

function App() {
  return (
    <>
      <HelmetProvider>
        <AuthProvider>
          <Router>
          <Routes>
          <Route path='/' element={<Home/>} />
          <Route path='/about' element={<About/>} />
          <Route path='/register' element={<Register/>} />
          <Route path='/register/verify-email' element={<VerifyEmail/>} />
          <Route path='/register/payment-card' element={<PaymentCard/>} />
          <Route path='/register/payment-detail' element={<PaymentDetail/>} />
          <Route path='/login' element={<Login/>} />
          <Route path='/forgot-password/send-mail' element={<ForgotPasswordSendMail/>} />
          <Route path='/forgot-password' element={<ForgotPassword/>} />

         
          <Route path='/dashboard-home' element={<ProtectedRoute><DashboardHome/></ProtectedRoute>} />
          <Route path='/dashboard' element={<ProtectedRoute><Dashboard/></ProtectedRoute>} />
          <Route path='/dashboard/documents' element={<ProtectedRoute><DashboardDocuments/></ProtectedRoute>} />
          <Route path='/dashboard/settings' element={<ProtectedRoute><DashboardSettings/></ProtectedRoute>} />
          <Route path='/dashboard/modules' element={<ProtectedRoute><DashboardModules/></ProtectedRoute>} />



        
          <Route path='/dashboard/modules/lesson-read' element={<ProtectedRoute><LessonRead/></ProtectedRoute>} />
          <Route path='/dashboard/modules/explanations' element={<ProtectedRoute><Explanation/></ProtectedRoute>} />
          <Route path='/dashboard/modules/quiz-question' element={<ProtectedRoute><QuizQuestion/></ProtectedRoute>} />
          <Route path='/dashboard/modules/quiz-pass' element={<ProtectedRoute><QuizPass/></ProtectedRoute>} />
          <Route path='/dashboard/modules/quiz-fail' element={<ProtectedRoute><QuizFail/></ProtectedRoute>} />
          <Route path='/dashboard/modules/audio-play' element={<ProtectedRoute><AudioPlay/></ProtectedRoute>} />
          <Route path='/dashboard/modules/image-or-gif' element={<ProtectedRoute><ImageOrGif/></ProtectedRoute>} />
          <Route path='/dashboard/modules/audio-card' element={<ProtectedRoute><AudioCard/></ProtectedRoute>} />
          <Route path='/dashboard/modules/table' element={<ProtectedRoute><Table/></ProtectedRoute>} />
          <Route path='/dashboard/modules/card-see' element={<ProtectedRoute><CardSee/></ProtectedRoute>} />
          <Route path='/dashboard/modules/card-hear' element={<ProtectedRoute><CardHear/></ProtectedRoute>} />
          <Route path='/dashboard/modules/card-do' element={<ProtectedRoute><CardDo/></ProtectedRoute>} />
          <Route path='/dashboard/modules/student-speaking' element={<ProtectedRoute><StudentSpeaking/></ProtectedRoute>} />
          <Route path='/dashboard/modules/student-card-correct' element={<ProtectedRoute><StudentCardCorrect/></ProtectedRoute>} />
          <Route path='/dashboard/modules/student-card-false' element={<ProtectedRoute><StudentCardFalse/></ProtectedRoute>} />
          <Route path='/dashboard/modules/syllable-see' element={<ProtectedRoute><SyllableSee/></ProtectedRoute>} />
          <Route path='/dashboard/modules/syllable-hear' element={<ProtectedRoute><SyllableHear/></ProtectedRoute>} />
          <Route path='/dashboard/modules/syllable-do' element={<ProtectedRoute><SyllableDo/></ProtectedRoute>} />
          <Route path='/dashboard/modules/syllable-student-speak' element={<ProtectedRoute><SyllableStudentSpeak/></ProtectedRoute>} />
          <Route path='/dashboard/modules/say-vowels' element={<ProtectedRoute><SayVowels/></ProtectedRoute>} />
          <Route path='/dashboard/modules/listen-to-teacher' element={<ProtectedRoute><ListenToTeacher/></ProtectedRoute>} />
          <Route path='/dashboard/modules/listen-to-teacher-correct' element={<ProtectedRoute><ListenToTeacherCorrect/></ProtectedRoute>} />
          <Route path='/dashboard/modules/listen-to-teacher-wrong' element={<ProtectedRoute><ListenToTeacherWrong/></ProtectedRoute>} />
          <Route path='/dashboard/modules/card-vowel-see' element={<ProtectedRoute><CardVowelSee/></ProtectedRoute>} />
          <Route path='/dashboard/modules/card-vowel-hear' element={<ProtectedRoute><CardVowelHear/></ProtectedRoute>} />
          <Route path='/dashboard/modules/card-vowel-do' element={<ProtectedRoute><CardVowelDo/></ProtectedRoute>} />
          <Route path='/dashboard/exam' element={<ProtectedRoute><ExamViewer/></ProtectedRoute>} />
          <Route path='/dashboard/certificate' element={<ProtectedRoute><CertificateViewer/></ProtectedRoute>} />
          </Routes>
          </Router>
        </AuthProvider>
      </HelmetProvider>
    </>
  );
}

export default App;
